import { render, staticRenderFns } from "./MotivoAbertura.vue?vue&type=template&id=25ad117d"
import script from "./MotivoAbertura.vue?vue&type=script&lang=js"
export * from "./MotivoAbertura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports